const DUAL = 'dual';
const PUBLIC = 'public';
const PRIVATE = 'private';

export { DUAL };
export { PUBLIC };
export { PRIVATE };
